import { render, staticRenderFns } from "./Request.vue?vue&type=template&id=dfb1822e&lang=pug&"
import script from "./Request.vue?vue&type=script&lang=ts&"
export * from "./Request.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports